import React, { PureComponent, lazy, Suspense } from 'react';
import { withTranslation } from 'react-i18next';
import { ClosedStatusChip } from '@workboard/ui-okr';
import GoalProgressBar from "../okr_depend_components/goalProgressBar.component";
import { okrDetailConstants } from "../../../constants/okr/okrDetails.constants";
import KrRow from "../okr_depend_components/krRow.component";
import Rating from '@material-ui/lab/Rating';
import { KeyDownEventLink, KeyDownEvent } from '../../../utils/eventKey';
import DisplayFiscalTimeFrames from './okrFiscalTime';
import { isReadOnlyUserLicenseType } from '../../../utils/common';
import { isKrStatusFilterEnabled } from '../../../utils/okrFilterParams.util';

const BarChartComp = lazy(() => import(
  /* webpackChunkName: "barchart" */
  '../../barchart'
));
const HamburgMenuComp = lazy(() => import(
  /* webpackChunkName: "hamburgmenu" */
  "../../hamburgmenu.component"
));
const RatingComp = lazy(() => import(
  /* webpackChunkName: "ratingComp" */
  "../okr_depend_components/ratingComp.component"
));
const ShortcutsBar = lazy(() => import(
  /* webpackChunkName: "shortcutsBar" */
  "../okr_depend_components/shortcutsBar.component"
));

const getLocationContext = () => {
	const searchParams = new URLSearchParams(window.location.search);
	const refSrc = searchParams.get('location');
	return refSrc;
};

class OkrRow extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			showGoalMetrics: null,
			showMetricList: false,
			showKrRows: this.props.showGoalMetricList,
			showCommentsId: null,
			dndDisplay: false
		}
		this.okrRowRightContainerRef = React.createRef();
		this.okrName = React.createRef();
		this.goalRatingWrapper = React.createRef();
		this.okrKrWrapper = React.createRef();
	}

	componentWillReceiveProps(nextProps){
		if(nextProps.showGoalMetricList != this.props.showGoalMetricList){
			this.setState({
				showKrRows: nextProps.showGoalMetricList
			})
		}
	}

	componentDidMount(){
		this.configureForIEnEdge();
	}

	configureForIEnEdge(){
		let ua = window.navigator.userAgent;
		let isIE = /MSIE|Trident/.test(ua);
		if( isIE ){
			this.okrKrWrapper.current.classList.add('ie');
			this.okrKrWrapper.current.classList.add('defineOkrWrapperWidth');
			if(this.props.progressType === okrDetailConstants.PROGRESS_TYPE_BAR){
				let height = this.okrName.current.offsetHeight;
				this.okrRowRightContainerRef.current.style.top = `${height - 5}px`;
				if(this.goalRatingWrapper.current){
					this.goalRatingWrapper.current.style.top = `-${height - 3}px`;
				}
			}
			let isSidebarOpen = document.querySelector('#leftmenu_navigation .leftmenu-wrapper').getAttribute("data-keepopen");
			if(isSidebarOpen == "false"){
				this.okrKrWrapper.current.classList.add("leftmenu-closed");
			}else{
				this.okrKrWrapper.current.classList.add("leftmenu-open");
			}
		}else{
			if(this.props.progressType === okrDetailConstants.PROGRESS_TYPE_BAR){
				let height = this.okrName.current.offsetHeight;
				this.okrRowRightContainerRef.current.style.top = `${height - 2}px`;
				if(this.goalRatingWrapper.current){
					this.goalRatingWrapper.current.style.top = `-${height - 6}px`;
				}
			}
		}
		if(/Edge/.test(ua)){
			this.okrKrWrapper.current.classList.add('edge');
		}
	}

	clickGoalRow = (e, goal, type = null) => {
		e.stopPropagation();
		e.preventDefault();
		let params = {};
		if (type == 'align') {
			params = { id: goal.id, t: 'alignspopup' }
		} else {
			params = { id: goal.id }
		}
		window.wb_track('OKR_ACTION', {
			location: getLocationContext(),
			locationDetail: 'Objectives_I_Own',
			objectAction: 'VIEW',
			object: 'OBJECTIVE',
			objectDetail: 'OKR_POPUP',
			objectId: goal.id,
		});
		params.onModalCloseCallback = () => {};
		viewGoalDetailsPage($(e.target), params);
	}

	handleShowGoalMetric = (e, goal, refSrc) => {
		e.preventDefault();
		e.stopPropagation();
		if(this.state.showKrRows){
			this.setState({
				...this.state,
				showKrRows:false,
				showMetricList: !this.state.showMetricList,
			},() => {
				okrShowHideKR(refSrc, 'OKR_SHOW_HIDE_KRS', 'HIDE')
			});
		}
		else {
			this.setState({
				...this.state,
				showMetricList: !this.state.showMetricList,
				showKrRows:true
			},() => {
				okrShowHideKR(refSrc, 'OKR_SHOW_HIDE_KRS', 'SHOW')
			});
		}
	}

	handleShortCutBar = (id) =>{
		this.props.handleShortCutBar(id);
	}

	handleDndEnable = (enabled) => {
		this.setState({ dndDisplay: enabled })
	}

	render() {
		const { t } = this.props;
		const { goal, userData,  showGoalMetricList, progressType, okrNameClass, noDaysClass, okrDependency,showOkrDependencyAlignment,showShortCutBar,displayKrConfidence,
			okrAlignment,showGoalName,showSourceName,type, onRefetchGoals } = this.props;

		// Team OKRs only, like the Closed pill on its KR rows.
		const showClosedChip = isKrStatusFilterEnabled(type)
			&& Number(goal.status) === okrDetailConstants.GOAL_CLOSED;
		const daysLeftText = `${(goal.days_left == '1') ? ` ${t('day left')}` : ` ${t('days left')}`} `;
		const style = {};
		const dateStyle = {};
		// if (i == total - 1) {
		style.borderBottomLeftRadius = '4px';
		dateStyle.borderBottomRightRadius = '4px';
		// }
		let refSrcRow = '';
		if (type) {
			let refSrc = type;
			if (refSrc == 'PAGE_TYPE_OKR_I_OWN' || refSrc == 'PAGE_TYPE_KR_I_UPDATE' || refSrc == 'PAGE_TYPE_MY_TEAM_OKR' || refSrc == 'PAGE_TYPE_MY_MANAGER_OKR') {
				refSrcRow = 'MY_OKR'
			} else if (refSrc == 'PAGE_TYPE_TEAM_TAB_OKR' || refSrc == 'PAGE_TYPE_MY_DIRECT_OKR' || refSrc == 'PAGE_TYPE_MY_DIRECT_KR') {
				refSrcRow = 'TEAM_OKR';
			} else if(refSrc == 'PAGE_TYPE_JUMP_TO_OKR') {
				refSrcRow = 'TEAM_OKR_JUMP';
			}
		}
		let customOkrSectionClass = this.state.showKrRows ? "opened-kr-rows" : "";
		let okrSectionClass = 'okr-section';
		let okrBarClass = {}
		if(progressType == okrDetailConstants.PROGRESS_TYPE_CIRCLE) {
			okrSectionClass += ' classWnDoughnutChart'
		}
		if (goal.okrPeriodType == 3 && goal.status == okrDetailConstants.GOAL_ACTIVE) {
			okrSectionClass += ' classCustomTimePeriod';
			okrBarClass = {
				paddingRight: '25px'
			}
		}
		const showDragandDropIcon = !this.state.dndDisplay ? 'screen-reader-only' : '';
		const showAriaExpandedCollapsedButton = (parseInt(goal.goal_metrics_count) > 0) && this.state.showKrRows ? true : false;
		let showAriaLabel = showAriaExpandedCollapsedButton ? t("Hide Key Results") : t("Show Key Results")
		let goalUrl = `${wbConfig.baseUrl}/okrs/objectives/${goal.id}`;
		return (
			<div className="okr-kr-wrapper" data-testid="okr-kr-wrapper" ref={this.okrKrWrapper} style={this.state.showKrRows || progressType !== okrDetailConstants.PROGRESS_TYPE_BAR  ? {marginBottom: "35px"}: {}}>

			{showGoalName ?

			<div className={`okr-row okr-row-dnd goal-okr-outline-mb ${customOkrSectionClass}`} data-goal-id={goal.id} key={`okr-row-${goal.id}`}
				onFocus={() => this.handleDndEnable(true)}
				onBlur={() => this.handleDndEnable(false)}
				onMouseEnter={() => this.handleDndEnable(true)}
				onMouseLeave={() => this.handleDndEnable(false)}
			>
				<a
					href={`${goalUrl}`}
					id={`objectives_list_${goal.id}`}
					className={okrSectionClass}
					onClick={(e) => this.clickGoalRow(e, goal)}
					onKeyDown={(e) => KeyDownEventLink(e, () => this.clickGoalRow(e, goal))
					}
				>
					{ this.props.dragHandleProps &&
						<div
							className={`okr-drag-and-drop-icon ${showDragandDropIcon}`}
							{...this.props.dragHandleProps}
							onKeyDown={(e) => { if (e.key === "Enter") {
								e.preventDefault();
								e.stopPropagation();
							} }}
						>
							<img src={`${wbConfig.imageCdnUrl}/images/dragDropCircle.svg`} alt="" />
						</div>
					}
					{(progressType == okrDetailConstants.PROGRESS_TYPE_CIRCLE) ?
						<div className="sepeChart">
							<div className="chart-dnd-teams">
								<Suspense fallback={null}>
									<BarChartComp count={goal.progress} color={goal.progress_color} radius={18} width={43} height={43} stroke={1} type={true}/>
								</Suspense>
							</div>
						</div> : ""
					}
					<div className="okr-col col-l col-l-dnd">
						<div className="width100">
							<div className="okr-col okr-goal-section okr-buttons"
								id={`okr-goal-section_button_${goal.id}`}
								onClick={(e) => this.clickGoalRow(e, goal)}
								onKeyDown={(e) => KeyDownEventLink(e, () => this.clickGoalRow(e, goal))}
								role="link"
								tabIndex={0}
							>
								<div role="heading" aria-level="4" data-testid='okr-name' className={`okr-name ${okrNameClass ? okrNameClass : ''} ${goal.status != okrDetailConstants.GOAL_ACTIVE ? "closed" : ""}`} ref={this.okrName} > {goal.goal}  {showClosedChip && <ClosedStatusChip />}</div>
								{(progressType == okrDetailConstants.PROGRESS_TYPE_BAR) ?
									<div className="okr-bar" data-testid="okr-progress-data" style={okrBarClass}>
										<GoalProgressBar key={`goal_progress_bar_${goal.id}`} percentage={goal.progress} color={goal.progress_color} />
										<div className="clear" />
										<div className="okr-inline-text truncateText ">
											<span className="screen-reader-only">{`${t('Owner')}:`}</span>
											{`${goal.firstname} ${goal.lastname}: `}
											<span className="screen-reader-only">{`${t('Team')}:`}</span>
											{goal.teamName}
										</div>
									</div> : ""
								}
							</div>
						</div>
					</div>
					<div className="okr-col col-r">
						<div className="okr-col okr-sec-right-container" ref={this.okrRowRightContainerRef}>
							<div className={"okr-col okr-view-details " + (progressType == okrDetailConstants.PROGRESS_TYPE_BAR ? 'forBarPrgsBar' : '')}>
								{
									(goal.status == okrDetailConstants.GOAL_ACTIVE)
										? (
											<div className="days-left-text">
												<span className={noDaysClass != '' ? noDaysClass : ""}>
												<span className="screen-reader-only">{t('Time Frame')}</span>
													<DisplayFiscalTimeFrames
														goal={goal}
														user={userData}
													/>
													<span className="dotClass" role="separator"></span>
													{goal.days_left}
													&nbsp;
                              						{daysLeftText}
                            					</span>
											</div>
										)
										: (
											refSrcRow == 'MY_OKR' &&
												<div className="goal-rating-wrapper" ref={this.goalRatingWrapper}>
													<Suspense fallback={null} >
														{/* <RatingComp key={`goal_rating_${goal.id}`} value={goal.rating} goalId={goal.id} /> */}
														<Rating
															key={`goal_rating_${goal.id}`}
															name="simple-controlled"
															value={goal.rating}
															readOnly={true}
															style={{ 'color': "#52bad5" }}
															size='small'
														/>
													</Suspense>
													<div className="closeGoalDetails">
															{
																goal.achieved_goal == 1
																	? <div className="goalAchievedText acheived">{t('ACHIEVED')}</div>
																	: <div className="goalAchievedText not-acheived">{t('NOT ACHIEVED')}</div>
															}
														<div><DisplayFiscalTimeFrames
														goal={goal}
														user={userData}
													/></div>
													</div>
												</div>
										)
								}

							</div>
							<div
								aria-expanded={showAriaExpandedCollapsedButton}
								aria-label={showAriaLabel}
								className="okr-col okr-carrot okrShowHideArrow"
								role="button"
								onClick={(e) => this.handleShowGoalMetric(e, goal, refSrcRow)}
								onKeyDown={e => KeyDownEvent(e, () => this.handleShowGoalMetric(e, goal, refSrcRow))}
								tabIndex={(parseInt(goal.goal_metrics_count) > 0) ? 0 : ""}
							>
								<div className="arrowIconShowHide">
									{
										(parseInt(goal.goal_metrics_count) > 0)
											? <div className={`icon icon-dropdown-14px ${this.state.showKrRows && this.props.showGoalMetricList ? ' icon-dropdown-up-14px '
											: this.state.showKrRows ? ' icon-dropdown-up-14px ':''}`} />
											: <div>&nbsp;</div>
									}
								</div>
							</div>
							{ !isReadOnlyUserLicenseType() && (<div className="okr-col okr-3dot-option" data-testid="okr-3dot-option">
								<Suspense fallback={null}>
									<HamburgMenuComp key={`goal_menu_${goal.id}`} menuAjax="1" type="goal" menuClass="goal-popup-menu" item={goal} refSrc={this.props.type} ariaLabel="Objectives Options" hamburgmenuId="hamburgmenu-parentid" onRefetchGoals={onRefetchGoals}/>
								</Suspense>
							</div>)}
							<div className="okr-col  okrAlignDepend">
								<div className="okrAlignment">
									{showOkrDependencyAlignment && (typeof okrAlignment != undefined && okrAlignment != '') ?
										<div onClick={(e) => this.clickGoalRow(e, goal, 'align')} style={{ display: 'inline', marginRight: '15px' }} title={okrAlignment>1 ? t("Aligned up to ") + okrAlignment +` ${t('OKRs')}` : `${t('Aligned up to')} ` + okrAlignment +` ${t('OKR')}`}>
											<span > {okrAlignment} </span>
											<i className="icon icon-arrow_upward-18px"></i>
										</div>
										: ""}
								</div>
								<div className="okrDependency">
									{showOkrDependencyAlignment && (typeof okrDependency != undefined && okrDependency != '') ?
										<div onClick={(e) => this.clickGoalRow(e, goal, 'align')} style={{ display: 'inline'}} title={okrDependency > 1 ? t("Dependent on ") + okrDependency + ` ${t('OKRs')}`:`${t('Dependent on')} ` + okrDependency + ` ${t('OKR')}`}>
											<span> {okrDependency} </span>
											<i className="icon icon-arrow_downward-18px"></i>
										</div>
										: ''}
								</div>
							</div>
						</div>
					</div>
					<div className="clear" />
				</a>
				{
					// this.state.showGoalMetrics == goal.id ? <GaolMetricCommentLists ref={refComp} key={`metric_comments_${goal.id}`} goal={goal} goalId={goal.id} userData={userData} /> : ''
				}
			</div>
			: ""  }

			{(showGoalMetricList && this.state.showKrRows) || (this.state.showKrRows && goal.goal_metrics.length > 0) ?
				<ul>{
					goal.goal_metrics && goal.goal_metrics.map((metric, index) => (
						<li key={index}>
						<KrRow
							metric={metric}
							dateStyle={dateStyle}
							style={style}
							loggedInUser={userData.id}
							goalStatus={goal.status}
							goalId={goal.id}
							teamId={goal.team_id}
							goalType = {goal.type}
							key={`kr-row-wrarpper-${metric.id}`}
							showSourceName={showSourceName}
							refSrc={this.props.type}
							emojisData={this.props.emojisData}
							showRealOwner={this.props.showRealOwner}
							displayKrConfidence={displayKrConfidence}
							clickedAlready={this.props.clickedAlready}
							cbClickedAlready={this.props.cbClickedAlready}
							parentMetricId={metric.parentMetricId || ''}
							isChildKr={ metric.parentMetricId ? true : false }
							addNewKrAction={this.props.addNewKrAction}
							deleteKrAction={this.props.deleteKrAction}
							notificationsData={this.props.notificationsData}
						/>
						{(typeof metric.nested_krs !== 'undefined' && metric?.nested_krs.length >= 1) && <ul> { metric.nested_krs.map((nestedMetric, index) => (
							<li key={index}>
							<KrRow
								metric={nestedMetric}
								dateStyle={dateStyle}
								style={style}
								loggedInUser={userData.id}
								goalStatus={goal.status}
								goalId={goal.id}
								teamId={goal.team_id}
								goalType={goal.type}
								key={`kr-row-wrarpper-${nestedMetric.id}`}
								showSourceName={showSourceName}
								refSrc={this.props.type}
								emojisData={this.props.emojisData}
								showRealOwner={this.props.showRealOwner}
								displayKrConfidence={displayKrConfidence}
								clickedAlready={this.props.clickedAlready}
								cbClickedAlready={this.props.cbClickedAlready}
								nestedKr={true}
								parentMetricId={metric.id}
								isChildKr={true}
								addNewKrAction={this.props.addNewKrAction}
								deleteKrAction={this.props.deleteKrAction}
								notificationsData={this.props.notificationsData}
							/></li>
							))}</ul>
						}

						</li>
					))}</ul>
					: ""
				}
				{
				((goal.closeOkrLabel) && showShortCutBar && this.props.goal.showShortCutOKR == 1 && goal.status == okrDetailConstants.GOAL_ACTIVE) ?
					<Suspense fallback={null}>
						<ShortcutsBar goal={goal} refSrc={refSrcRow} refType='OKR_ARCHIVE' handleShortCutBar={this.handleShortCutBar}></ShortcutsBar>
					</Suspense>
					: null
				}
				{
					goal.goal_metrics.length === 0 && progressType == okrDetailConstants.PROGRESS_TYPE_BAR
						?	<div className="divider-line16"></div>
						: ((!this.state.showKrRows && progressType == okrDetailConstants.PROGRESS_TYPE_BAR) ? <div className="divider-line16"></div> : null)
				}

			</div>
		);
	}
}

OkrRow.defaultProps = {
	progressType: 'BAR',
	showGoalName: true,
	userData: {},
	okrNameClass : '',
	noDaysClass : '',
	okrDependency : '',
	okrAlignment : '',
	showOkrDependencyAlignment: false,
	type: '',
	showShortCutBar: false
}

export default withTranslation()(OkrRow);
